<template>
  <button
    @click="loadFlyerPage"
    type="button"
    :class="[from === 'nav' 
    ? 'tw-flex tw-items-center tw-justify-center tw-gap-x-1 tw-bg-gradient-btg tw-py-2 tw-px-3 tw-text-white hover:tw-text-white tw-font-semibold tw-text-sm tw-rounded-lg tw-w-full focus:tw-ring focus:tw-ring-primary-100'
    : 'tw-relative focus:[outline-style:auto] focus:tw-outline-auto focus:tw-outline-2 focus:tw-outline-primary-700']"
  >
    <span v-if="from === 'nav'" class="material-symbols-outlined tw-leading-none tw-text-lg">description</span>
    <span class="tw-px-0.5">{{ localize("weeklyFlyer") }}</span>
  </button>
</template>

<script setup lang="ts">
import { ref } from "vue";
import analyticsService from "lib/workperks/services/AnalyticsService";
import { TrackingAction } from "lib/workperks/models/Analytics";

const cdn = ref(window.v.cdn || "");

const props = withDefaults(defineProps<{
  from?: 'nav' | 'footer';
}>(), {
  from: 'nav',
});

const dictionary = {
  en: {
    weeklyFlyer: "Flyers",
  },
  fr: {
    weeklyFlyer: "Circulaires",
  },
};

const localize = (key: string) => {
  const lang = window.l.locale || "en";
  return dictionary[lang]?.[key] || dictionary.en[key];
};

const loadFlyerPage = async () => {
  if (analyticsService.isInitialized) {
    props.from === 'nav' && analyticsService.setTemplateId(null).trackWeeklyFlyerTopButton(TrackingAction.Click)
    props.from === 'footer' && analyticsService.setTemplateId(null).trackWeeklyFlyerFooterButton(TrackingAction.Click);
  }

  window.location.href = '/flyers';
};

defineExpose({
  localize,
  loadFlyerPage,
});
</script>
